import { Button } from "@/components/ui/Button";

interface FollowUpChipsProps {
  questions: string[];
  onPick: (question: string) => void;
}

export function FollowUpChips({ questions, onPick }: FollowUpChipsProps) {
  if (!questions || questions.length === 0) return null;

  return (
    <div className="mt-3 flex flex-wrap gap-2" aria-label="Suggested follow-up questions">
      {questions.map((question) => (
        <Button
          key={question}
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onPick(question)}
          className="h-auto whitespace-normal rounded-pill border border-border px-3 py-[5px] text-[12px] leading-snug text-text-muted hover:border-ndc-red hover:bg-ndc-red-tint hover:text-text focus-visible:ring-ndc-red focus-visible:ring-offset-[var(--bg)]"
        >
          {question}
        </Button>
      ))}
    </div>
  );
}
